import React from "react";
import PropTypes from "prop-types";
import stripHtml from "../../utils/stripHtml";
import schemaDate from "../../utils/schemaDate";
import schemaPlace from "../../utils/schemaPlace";
import schemaPrice from "../../utils/schemaPrice";
import poiImages from "../../utils/poiImages";

const markup = htmlContent => ({ __html: htmlContent });

const EventSchema = ({ poi }) => {
  const {
    address,
    containingPlace: place,
    hoursString: date,
    name,
    priceString: price,
    review,
    slug,
  } = poi;

  const hasPerformer = false;
  const places = schemaPlace(place);
  const dates = schemaDate(date);
  const images = poiImages({ poi });

  const schema = {
    "@context": "http://schema.org",
    "@type": "Event",
    name,
    startDate: dates.startDate,
    location: {
      "@type": "Place",
      name,
      address: {
        "@type": "PostalAddress",
        streetAddress: address.street,
        addressLocality: places.city,
        postalCode: "",
        addressRegion: places.region,
        addressCountry: places.country,
      },
    },
    image: (images && images.length) ? images[0] : "",
    description: stripHtml((review && review.essential) ? review.essential : ""),
    endDate: dates.endDate,
  };

  if (price) {
    schema.offers = {
      "@type": "Offer",
      url: `https://www.lonelyplanet.com/${slug}`,
      price: schemaPrice(price),
      priceCurrency: "USD",
      availability: "",
      validFrom: "",
    };
  }

  if (hasPerformer) {
    schema.performer = {
      "@type": "PerformingGroup",
      name: "",
    };
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={markup(JSON.stringify(schema))}
    />
  );
};

EventSchema.propTypes = {
  poi: PropTypes.shape({
    address: PropTypes.shape({
      street: PropTypes.string,
    }),
    containingPlace: PropTypes.shape({
      ancestry: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        placeType: PropTypes.string,
      })),
      name: PropTypes.string,
      placeType: PropTypes.string,
    }),
    hoursString: PropTypes.string,
    imageAssociations: PropTypes.object,
    name: PropTypes.string,
    priceString: PropTypes.string,
    review: PropTypes.shape({
      essential: PropTypes.string,
    }),
    slug: PropTypes.string,
  }).isRequired,
};

export default EventSchema;



// WEBPACK FOOTER //
// ./assets/pois/components/schema/schemaEvent.jsx